import { render, staticRenderFns } from "./DataInfos.vue?vue&type=template&id=6ff0211f&"
import script from "./DataInfos.vue?vue&type=script&lang=js&"
export * from "./DataInfos.vue?vue&type=script&lang=js&"
import style0 from "./DataInfos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports